'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, cn, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@repo/ui';
import { Check, Chevron } from '@repo/ui/icons';
import type { ChainId } from '../../web3.types';
import { getChainShortName } from '../../utils/chain.utils';
import { ChainIcon } from '../ChainIcon';
import { MultiChainIcon } from './MultiChainIcon';
interface ChainFilterDropdownProps {
  chains: ChainId[];
  selectedChain?: ChainId;
  onChainSelect: (chain: ChainId | undefined) => void;
  allowAll?: boolean;
  showLabel?: boolean;
  triggerClassName?: string;
  triggerTestId?: string;
  itemTestIdPrefix?: string;
}
export function ChainFilterDropdown(props) {
  const $ = _c(37);
  const {
    chains,
    selectedChain,
    onChainSelect,
    allowAll: t0,
    showLabel: t1,
    triggerClassName,
    triggerTestId,
    itemTestIdPrefix
  } = props;
  const allowAll = t0 === undefined ? true : t0;
  const showLabel = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== allowAll || $[1] !== selectedChain) {
    t2 = selectedChain ? <ChainIcon chainId={selectedChain} className="size-5 rounded-full" /> : allowAll ? <MultiChainIcon /> : null;
    $[0] = allowAll;
    $[1] = selectedChain;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const triggerIcon = t2;
  let t3;
  if ($[3] !== allowAll || $[4] !== selectedChain) {
    t3 = selectedChain ? getChainShortName(selectedChain) : allowAll ? "All networks" : "Select network";
    $[3] = allowAll;
    $[4] = selectedChain;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const triggerLabel = t3;
  let t4;
  if ($[6] !== triggerClassName) {
    t4 = cn("group px-xs flex h-7 items-center gap-1.5", triggerClassName);
    $[6] = triggerClassName;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== showLabel || $[9] !== triggerLabel) {
    t5 = showLabel && <span>{triggerLabel}</span>;
    $[8] = showLabel;
    $[9] = triggerLabel;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Chevron className="size-5 transition-transform group-data-[state=open]:-rotate-180" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== triggerIcon || $[15] !== triggerTestId) {
    t7 = <DropdownMenuTrigger asChild={true}><Button type="button" variant="secondary" size="sm" className={t4} data-testid={triggerTestId}>{triggerIcon}{t5}{t6}</Button></DropdownMenuTrigger>;
    $[12] = t4;
    $[13] = t5;
    $[14] = triggerIcon;
    $[15] = triggerTestId;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== allowAll || $[18] !== itemTestIdPrefix || $[19] !== onChainSelect || $[20] !== selectedChain) {
    t8 = allowAll && <DropdownMenuItem onClick={() => onChainSelect(undefined)} className="flex cursor-pointer items-center gap-3" data-testid={itemTestIdPrefix ? `${itemTestIdPrefix}-all` : undefined}><MultiChainIcon /><span className="flex-1">All networks</span>{!selectedChain && <Check className="size-5" />}</DropdownMenuItem>;
    $[17] = allowAll;
    $[18] = itemTestIdPrefix;
    $[19] = onChainSelect;
    $[20] = selectedChain;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== chains || $[23] !== itemTestIdPrefix || $[24] !== onChainSelect || $[25] !== selectedChain) {
    let t10;
    if ($[27] !== itemTestIdPrefix || $[28] !== onChainSelect || $[29] !== selectedChain) {
      t10 = chainId => <DropdownMenuItem key={chainId} onClick={() => onChainSelect(chainId)} className="flex cursor-pointer items-center gap-3" data-testid={itemTestIdPrefix ? `${itemTestIdPrefix}-${chainId}` : undefined}><ChainIcon chainId={chainId} className="size-5 rounded-full" /><span className="flex-1">{getChainShortName(chainId)}</span>{selectedChain === chainId && <Check className="size-5" />}</DropdownMenuItem>;
      $[27] = itemTestIdPrefix;
      $[28] = onChainSelect;
      $[29] = selectedChain;
      $[30] = t10;
    } else {
      t10 = $[30];
    }
    t9 = chains.map(t10);
    $[22] = chains;
    $[23] = itemTestIdPrefix;
    $[24] = onChainSelect;
    $[25] = selectedChain;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[31] !== t8 || $[32] !== t9) {
    t10 = <DropdownMenuContent align="end" className="w-56">{t8}{t9}</DropdownMenuContent>;
    $[31] = t8;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== t10 || $[35] !== t7) {
    t11 = <DropdownMenu>{t7}{t10}</DropdownMenu>;
    $[34] = t10;
    $[35] = t7;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  return t11;
}